export default {
  async created () {
    await this.$store.dispatch('currentDoc/loadDoc')
  }
}
